import * as React from 'react';
import { Modal, Input } from 'antd';
import Form, { FormItem } from '../../../../../../components/Form';
// import LanguageSelect from '../../../../../../components/Others/LanguageSelect';

interface IProductVideoDetailProps {
  productId: string;
  video: GQL.IProductVideo | undefined | null;
  languages?: Array<GQL.ILanguage>;
  onClose: Function;
  onSave: (video: GQL.IProductVideo) => void;
}

interface IProductVideoDetailState {
  data: any;
  currentLanguage: string;
}

class ProductVideoDetail extends React.Component<IProductVideoDetailProps, IProductVideoDetailState> {

  private form;

  constructor(props: IProductVideoDetailProps) {
    super(props);

    this.state = {
      data: props.video ? {
        id: props.video.id,
        url: props.video.url,
        title: props.video.title,
        priority: props.video.priority,
        visible: props.video.visible,
      } : {},
      currentLanguage: props.languages ? props.languages.map(l => l.value)[0] : 'en',
    }

    this.form = React.createRef;

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  public render() {
    const { video } = this.props;
    const { data, currentLanguage } = this.state;

    return (
      <Modal 
        maskClosable={false}
        title={
          <>
            {video == undefined
              ? 'New product video'
              : <span>Product video</span>}
              {/* &nbsp;&ndash;&nbsp; */}
            {/* <LanguageSelect
              name={'language'}
              value={currentLanguage}
              onChange={(e: any, language: GQL.ILanguage) => this.setState({ currentLanguage: language.value })}
            /> */}
          </>
        }
        visible={true}
        cancelText={'Close'}
        okText={'Save changes'}
        onOk={this.onSubmit}
        onCancel={(e: any) => this.props.onClose(e)}
      >
        <Form
          ref={f => this.form = f}
          displayFooter={false}
          onSubmit={this.onSubmit}
          onCancel={this.props.onClose}
        >
          <FormItem label={'Url'} required={true}>
            <Input 
              name='url'
              autoFocus={true}
              placeholder={'Embed video link'}
              value={data.url || ''}
              required={true}
              onChange={this.onChange}
            />
          </FormItem>
          {/* <FormItem label={'Title'}>
            <Input 
              name='title'
              value={data.title && data.title[this.state.currentLanguage]}
              addonAfter={this.state.currentLanguage}
              onChange={(e: any) => this.onChange(e, currentLanguage)}
            />
          </FormItem> */}
        </Form>
      </Modal>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    let inputValue = (value !== undefined ? value : checked);

    if (name === 'url') {
      inputValue = inputValue.replace('https://vimeo.com/', 'https://player.vimeo.com/video/');
    }

    const newValue = (language 
        ? { [name]: { ...this.state.data[name], [language]: inputValue }} 
        : { [name]: inputValue });

    this.setState({
        data: { ...this.state.data, ...newValue }
    });
  }

  private onSubmit(e: any) {
    if (this.form) {
      if (this.form.validate()) {
        this.props.onSave(this.state.data);
      }
    }
  }
}

export default ProductVideoDetail;


// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/ProductVideos/ProductVideoDetail/ProductVideoDetail.tsx